import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addIssueCountry, deleteIssueCountry, getAllIssueCountry, updateIssueCountry } from '../../redux/rtk/features/masters/issueCountrySlice';
import PageTitle from '../page-header/PageHeader';

const CountryOfIssueMaster = () => {
  const { Title } = Typography;

  const [editingissueCountry, setEditingissueCountry] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.issueCountry);

  useEffect(() => {
    dispatch(getAllIssueCountry());
  }, [dispatch]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingissueCountry) {
        // Update existing issueCountry
        const result = await dispatch(
          updateIssueCountry({ id: editingissueCountry.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllIssueCountry());
        } else {
          message.error('Error updating issueCountry!');
        }
      } else {
        // Add new issueCountry
        const result = await dispatch(addIssueCountry(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllIssueCountry());
        } else {
          message.error('Error adding issueCountry!');
        }
      }
      setEditingissueCountry(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      // message.error('Failed to add or update issueCountry!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteIssueCountry(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllIssueCountry()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Country of Issue',
      dataIndex: 'issueCountry',
      key: 'issueCountry',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {setEditingissueCountry(record); form.setFieldsValue(record)}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this country of issue?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
        <Card title={editingissueCountry ? 'Edit Country of Issue' : 'Add Country of Issue'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="country-of-issue-form"
              labelCol={{ span: 14 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
          <Form.Item
            name="issueCountry"
            label="Country Of Issue"
            rules={[{ required: true, message: 'Please enter a country of issue!' }]}
          >
            <Input placeholder="Enter country of issue " />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingissueCountry ? 'Update Country Of Issue' : 'Add Country Of Issue'}
              </Button>
            </Form>
        </Card>
        </Col>
        <Col span={16}>
          <Card title="Country Of Issue List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
        </Row>
    </div>
  );
};

export default CountryOfIssueMaster;
